import { Injectable } from '@angular/core';
import { DryEyeMedicalHistoryFormGroup } from 'src/app/shared/consult-forms/dry-eye-forms/dry-eye-medical-history-form/dry-eye-medical-history-form.model';
import { splitMedicationFreeText } from '../medication/medication-free-text.util';
import { MedicalHistoryPopulator } from '../medical-history-source.model';
import { MedicationReconciler } from '../medication/medication-reconciler';

/**
 * Applies a SPEED questionnaire, which only contributes patient-entered
 * medications. The staged entries are folded into `medications` later by the
 * MedicationReconciler.
 */
@Injectable({ providedIn: 'root' })
export class SpeedPopulator implements MedicalHistoryPopulator {
  constructor(private medicationReconciler: MedicationReconciler) {}

  populate(formGroup: DryEyeMedicalHistoryFormGroup, answers: any): void {
    const speedAnswers = answers && answers['SPEED'];
    if (!speedAnswers) {
      return;
    }
    // splitMedicationFreeText normalises strings, arrays and unexpected shapes
    // (numbers/objects → []), so the map below never sees a non-array.
    const processedEntries = splitMedicationFreeText(speedAnswers.patientEnteredMedications).map(
      entry =>
        typeof entry === 'string' ? this.medicationReconciler.createDrugFromString(entry) : entry
    );
    if (!processedEntries.length) {
      return;
    }
    const currentFreeText = formGroup.controls.patientEnteredMedicationsFreeText.value;
    formGroup.controls.patientEnteredMedicationsFreeText.patchValue([
      ...splitMedicationFreeText(currentFreeText),
      ...processedEntries
    ]);
  }
}
